const toCapitalizeFirst = (phrase: string) => {
	const words = phrase.split(' ').map(word => word.trim())
	return words.map(word => word[0].toUpperCase() + word.slice(1)).join(' ')
}

export { toCapitalizeFirst }
